import api from './api';

const SubjectService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/subjects/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/subjects/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/subjects/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/subjects/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  partialUpdate: async (id, data) => {
    try {
      const response = await api.patch(`/subjects/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/subjects/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default SubjectService;
